module.exports = __webpack_public_path__ + "img/tattoo4.8d708d26.jpg";